import { Spin } from 'antd';

type Props = {
  message?: string;
  /** When false, only covers the parent (position: absolute). Default: full viewport. */
  fullScreen?: boolean;
};

export function ScreenLoader({ message = 'Please wait…', fullScreen = true }: Props) {
  return (
    <div
      className={`screen-loader${fullScreen ? ' screen-loader--viewport' : ''}`}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="screen-loader__card">
        <Spin size="large" />
        <p className="screen-loader__message">{message}</p>
      </div>
    </div>
  );
}

export function PageLoader({ message }: { message?: string }) {
  return <ScreenLoader message={message} fullScreen />;
}
